import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { loadAndApplyTheme } from "./lib/theme";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Register from "./pages/Register";
import RegisterSuccess from "./pages/RegisterSuccess";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PendingApprovals from "./pages/PendingApprovals";
import ApprovedStudents from "./pages/ApprovedStudents";
import Courses from "./pages/Courses";
import MobilePhoto from "./pages/MobilePhoto";
import MobileSign from "./pages/MobileSign";
import Settings from "./pages/Settings";
import PublicPayment from "./pages/PublicPayment";
import Receipts from "./pages/Receipts";
import Users from "./pages/Users";
import Companies from "./pages/Companies";
import Placements from "./pages/Placements";
import TrackPortal from "./pages/TrackPortal";

function App() {
  React.useEffect(() => { loadAndApplyTheme(); }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/success" element={<RegisterSuccess />} />
          <Route path="/login" element={<Login />} />
          <Route path="/m/photo/:token" element={<MobilePhoto />} />
          <Route path="/m/sign/:token" element={<MobileSign />} />
          <Route path="/pay/:token" element={<PublicPayment />} />
          <Route path="/track/:token" element={<TrackPortal />} />

          <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin/pending" element={<ProtectedRoute><PendingApprovals /></ProtectedRoute>} />
          <Route path="/admin/approved" element={<ProtectedRoute><ApprovedStudents /></ProtectedRoute>} />
          <Route path="/admin/courses" element={<ProtectedRoute><Courses /></ProtectedRoute>} />
          <Route path="/admin/receipts" element={<ProtectedRoute><Receipts /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
          <Route path="/admin/companies" element={<ProtectedRoute><Companies /></ProtectedRoute>} />
          <Route path="/admin/placements" element={<ProtectedRoute><Placements /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute roles={["admin", "manager"]}><Settings /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
